export const GET_ALL_RESERVOIR_REQUEST = "GET_ALL_RESERVOIR_REQUEST";
export const GET_ALL_RESERVOIR_SUCCESS = "GET_ALL_RESERVOIR_SUCCESS";
export const GET_ALL_RESERVOIR_FAIL = "GET_ALL_RESERVOIR_FAIL";

export const GET_RESERVOIR_REQUEST = "GET_RESERVOIR_REQUEST";
export const GET_RESERVOIR_SUCCESS = "GET_RESERVOIR_SUCCESS";
export const GET_RESERVOIR_FAIL = "GET_RESERVOIR_FAIL";

export const ADD_RESERVOIR_REQUEST = "ADD_RESERVOIR_REQUEST";
export const ADD_RESERVOIR_SUCCESS = "ADD_RESERVOIR_SUCCESS";
export const ADD_RESERVOIR_FAIL = "ADD_RESERVOIR_FAIL";

export const UPDATE_RESERVOIR_REQUEST = "UPDATE_RESERVOIR_REQUEST";
export const UPDATE_RESERVOIR_SUCCESS = "UPDATE_RESERVOIR_SUCCESS";
export const UPDATE_RESERVOIR_FAIL = "UPDATE_RESERVOIR_FAIL";

export const DELETE_RESERVOIR_REQUEST = "DELETE_RESERVOIR_REQUEST";
export const DELETE_RESERVOIR_SUCCESS = "DELETE_RESERVOIR_SUCCESS";
export const DELETE_RESERVOIR_FAIL = "DELETE_RESERVOIR_FAIL";
